class SubscriptionService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.authenticationService = authenticationService;
        this.token = this.authenticationService.getToken();
        this.globalConstants = globalConstants;
    }

    getSubscriptions() {
        //TODO: probably nicer way of doing queryString
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/subscriptions'
        });
    }

    deleteSubscription(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/subscriptions/deletesubscription/',
            params: { id: id}
        });
    }

    getCreditsForSubscription(subscriptionId) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/subscriptions/getCreditsForSubscription/',
            params: { subscriptionId: subscriptionId}
        });
    }
}

export default SubscriptionService;


// WEBPACK FOOTER //
// ./src/js/services/subscription.service.js